// extracted by mini-css-extract-plugin
export default {"wrapper":"xy-z","viewport":"yy-z","container":"zy-z","slide":"Ay-z"};